module.exports = __webpack_public_path__ + "img/default_user.c96be867.png";